import script from "./AiView.vue?vue&type=script&setup=true&lang=js"
export * from "./AiView.vue?vue&type=script&setup=true&lang=js"

import "./AiView.vue?vue&type=style&index=0&id=6322f5b3&scoped=true&lang=css"
import "./AiView.vue?vue&type=style&index=1&id=6322f5b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6322f5b3"]])

export default __exports__